export default [
  {
    path: '/credit-pay',
    component: () => import('@/pages/credit-pay/Index.vue'),
    children: [
      {
        name: 'credit-pay',
        path: '',
        meta: { design: { classes: [] } },
        component: () => import('@/pages/credit-pay/Main.vue'),
      },
      {
        name: 'credit-pay/requests/form',
        path: 'requests/form',
        meta: { title: '신청', design: { classes: [] } },
        component: () => import('@/pages/credit-pay/requests/Form.vue'),
      },
      {
        name: 'credit-pay/requests',
        path: 'requests',
        meta: { title: '신청 내역', design: { classes: ['full-height'] } },
        component: () => import('@/pages/credit-pay/requests/History.vue'),
      },
      {
        name: 'credit-pay/requests/detail',
        path: 'requests/:uuid',
        meta: {
          title: '신청 상세',
          topPages: [{ title: '신청 내역', name: 'credit-pay/requests' }],
          design: { classes: [] },
        },
        props: (route) => ({ uuid: route.params.uuid }),
        component: () => import('@/pages/credit-pay/requests/Detail.vue'),
      },
    ],
  },
]
